import * as React from "react";

import styled from "styled-components";

export interface BackIconProps {
  className?: string;
  isDark?: boolean;
  onClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

const BackIcon: React.FC<BackIconProps> = (props) => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={(ev) => (props.onClick ? props.onClick(ev) : null)}
    >
      <circle cx="25" cy="25" r="25" />
      <path
        className="path"
        d="M31 24h-9.6l3.3-3.3c0.4-0.4 0.4-1 0-1.4s-1-0.4-1.4 0l-5 5c-0.1 0.1-0.2 0.2-0.2 0.3 -0.1 0.2-0.1 0.5 0 0.8 0.1 0.1 0.1 0.2 0.2 0.3l5 5C23.5 30.9 23.7 31 24 31s0.5-0.1 0.7-0.3c0.4-0.4 0.4-1 0-1.4L21.4 26H31c0.6 0 1-0.4 1-1S31.6 24 31 24z"
      />
    </svg>
  );
};

export default styled(BackIcon)`
  cursor: pointer;

  &:hover {
    circle {
      fill: "#fff";
    }
  }

  circle {
    fill: #424242;
    transition: fill;
  }

  .path {
    fill: #fff;
  }
`;
